// removed by extract-text-webpack-plugin
module.exports = {"gst-button":"gst-calculator__gst-button___3hDTP"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/gst-calculator.scss
// module id = 1327
// module chunks = 0